import {SearchContent} from './searchContent';

class ContentLoader
{
    /**
     * @param {string|null} searchQuery
     */
    static loadContent(searchQuery) {
        clearTimeout(window.allBrandsSerchTimeout);
        window.allBrandsSerchTimeout = setTimeout(() => {
            let statusHandler = document.querySelector('[data-search="status"]'),
                dropSearchButton = document.querySelector('[data-search="drop"]'),
                searchInput = document.querySelector('[data-action="search-brand"]');

            /** @param {{content: string, count: int}} contentData */
            new SearchContent(searchInput.getAttribute('data-endpoint'), searchQuery, (contentData) => {
                if (contentData.count) {
                    document.querySelector('[data-search="content"]').innerHTML = contentData.content;
                    statusHandler.textContent = statusHandler.getAttribute('data-found') + ' ' + contentData.count;
                } else {
                    statusHandler.textContent = statusHandler.getAttribute('data-error');
                }

                statusHandler.classList.toggle('is-none', !searchQuery);
                dropSearchButton.classList.toggle('is-none', !searchQuery);
            });
        }, 1000);
    }
}

export {ContentLoader};
